// Loading states of the signed-in shell (spec §11.8: skeletons, no spinners in content areas). They live in the entry
// chunk: the whole-shell placeholder shows while the shell chunk loads, the content skeleton while a route chunk loads
// and before READY, the sidebar skeleton until READY.
import { useTranslation } from 'react-i18next';
import { Skeleton } from '@moods/ui';

export function SidebarSkeleton() {
  const { t } = useTranslation('shell');
  return (
    <aside className="md-panel shell-sidebar" aria-busy="true" aria-label={t('loading.sidebar')}>
      <div className="shell-skel">
        {Array.from({ length: 9 }, (_, i) => (
          <Skeleton key={i} w={`${60 + ((i * 17) % 35)}%`} h={14} />
        ))}
      </div>
    </aside>
  );
}

export function MainSkeleton() {
  const { t } = useTranslation('shell');
  return (
    <main className="md-panel md-panel--content md-main" aria-busy="true" aria-label={t('loading.content')}>
      <div className="shell-skel shell-skel--main">
        {Array.from({ length: 6 }, (_, i) => (
          <div key={i} className="shell-skel-row">
            <Skeleton w={40} h={40} circle />
            <div style={{ flex: 1 }}>
              <Skeleton w={140} h={12} style={{ marginBottom: 8 }} />
              <Skeleton w={`${45 + ((i * 11) % 40)}%`} h={12} />
            </div>
          </div>
        ))}
      </div>
    </main>
  );
}

/** The floating workspace without data: rail, sidebar and content placeholders (while the shell chunk loads). */
export function ShellSkeleton() {
  return (
    <div className="md-app md-root shell">
      <div className="md-app-body shell-body">
        <div id="shell-nav" className="shell-nav">
          <div className="md-rail" aria-hidden="true">
            <div className="shell-skel shell-skel--rail">
              {Array.from({ length: 5 }, (_, i) => (
                <Skeleton key={i} w={44} h={44} style={{ borderRadius: 'var(--radius-lg)' }} />
              ))}
            </div>
          </div>
          <SidebarSkeleton />
        </div>
        <div className="shell-content">
          <MainSkeleton />
        </div>
      </div>
    </div>
  );
}
